import { render, staticRenderFns } from "./chartCriteria.vue?vue&type=template&id=9f7bef72"
import script from "./chartCriteria.vue?vue&type=script&lang=js"
export * from "./chartCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports